import Nullstack from 'nullstack';
export default function IconCurrencyRupeeNepalese({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-currency-rupee-nepalese",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M15 5h-11h3a4 4 0 1 1 0 8h-3l6 6"
  }), "   ", Nullstack.element("path", {
    d: "M21 17l-4.586 -4.414a2 2 0 0 0 -2.828 2.828l.707 .707"
  }), " ");
}